import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-section-loader',
    templateUrl: './section-loader.component.html',
    styleUrls: ['./section-loader.component.scss'],
    standalone: false
})
export class SectionLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
